import { FormNameType } from 'utils/types'
import { yup, YUP_ERROR_MESSAGE } from 'components/form/yup'
import { EMAIL_RULE, FIRST_NAME_RULE, LAST_NAME_RULE, ZIP_CODE_RULE } from 'components/form-field'
import { ISubscribeFormData } from 'api/nest/home-sellers/types'

export const SUBSCRIBE_FIELDS_NAME: FormNameType<ISubscribeFormData> = {
  lastName: 'lastName',
  firstName: 'firstName',
  email: 'email',
  postalCode: 'postalCode',
  agreeEmailSubscription: 'agreeEmailSubscription',
}

export const SUBSCRIBE_VALIDATOR = yup.object().shape({
  [SUBSCRIBE_FIELDS_NAME.firstName]: FIRST_NAME_RULE,
  [SUBSCRIBE_FIELDS_NAME.lastName]: LAST_NAME_RULE,
  [SUBSCRIBE_FIELDS_NAME.email]: EMAIL_RULE,
  [SUBSCRIBE_FIELDS_NAME.postalCode]: ZIP_CODE_RULE,
  [SUBSCRIBE_FIELDS_NAME.agreeEmailSubscription]: yup
    .boolean()
    .required()
    .oneOf([true], YUP_ERROR_MESSAGE.mixed?.required),
})
